"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NDocs = void 0;
const helper_1 = require("../../helper");
const EmrConstants_1 = require("../../EmrConstants");
class NDocs {
    constructor() { }
    parse(pastedData, event, callbackEmit) {
        pastedData = pastedData.replace(/\r\n/g, "\n");
        try {
            const patientInfo = this.gettingPatientDetails(pastedData);
            const insurance = this.getInsurance(pastedData);
            const contactInformationRaw = (0, helper_1.substrInBetweenNew)(pastedData, "Care Directory\n", "..........");
            const contactDetails = this.getContactDetails(contactInformationRaw);
            const sendCallBackData = Object.assign(Object.assign(Object.assign({}, patientInfo), insurance), contactDetails);
            //@callback
            callbackEmit({ parseData: sendCallBackData });
        }
        catch (error) {
            //For Error logs
            callbackEmit({
                parseData: {},
                isDataParsed: 0,
                errorMessage: error ? error === null || error === void 0 ? void 0 : error.message : error,
                errorStack: error === null || error === void 0 ? void 0 : error.stack,
            });
        }
    }
    /**
     * @function gettingPatientDetails
     * @param sessionFirst {String}
     * @param sessionSecond {String}
     * @summary Getting Patient name, number, email, dob, address from Synergy
     */
    gettingPatientDetails(sessionFirst) {
        const Dob = (0, helper_1.substrInBetween)(sessionFirst, "DOB:", "Sex:");
        const name = (0, helper_1.substrInBetween)(sessionFirst, "Patient Name:", "Acct #:");
        return {
            patientInfo: Object.assign(Object.assign(Object.assign({}, this.patientName(name)), this.patientPhoneNumberWithAddress(sessionFirst)), { dob: (0, helper_1.getDOB)(Dob, true) }),
        };
    }
    /**
     * @function getInsurance
     * @param sessionThird
     * @summary Getting Insurance from Synergy
     */
    getInsurance(sessionThird) {
        return {
            insurance: (0, helper_1.substrInBetween)(sessionThird, "Primary Insurance:", "Primary Policy:"),
        };
    }
    /**
     * @function getPrimaryPhysician
     * @param data
     * @param sessionEight
     * @summary Getting Physician and Pharmacy from Synergy
     */
    getContactDetails(contactDetails) {
        const caregiverRaw = (0, helper_1.substrInBetweenInclusive)(contactDetails, "\nEmergency Contact: ", "\nRelation to Patient: ");
        const physiciansRaw = (0, helper_1.substrInBetweenInclusive)(contactDetails, "Physicians\n", "\nNPI:");
        const pharmacyRaw = (0, helper_1.substrInBetweenInclusive)(contactDetails, "\nPharmacies", "..........");
        const primaryPhy = {
            info: {
                physician: this.getPhysician(physiciansRaw),
                pharmacy: this.getPharmacy(pharmacyRaw),
                careGiver: this.getCaregiver(caregiverRaw),
            },
        };
        //@Return
        return primaryPhy;
    }
    getPhysician(data) {
        const physicians = [];
        const physicianNameRaw = (0, helper_1.substrInBetweenNew)(data, "Primary Physician:", "\n");
        const physicianNameParts = physicianNameRaw.split(",");
        const name = `${physicianNameParts[1]} ${physicianNameParts[0]}`;
        const numbersRaw = (0, helper_1.substrInBetweenNew)(data, "Work Phone:", "\n");
        const phoneNo = (0, helper_1.changeNumberUSFormat)((0, helper_1.trim)(numbersRaw.replace(/[\s-()]/g, "")));
        if (name && phoneNo) {
            physicians.push({
                name,
                phoneNo,
                countryCode: EmrConstants_1.DEFAULT_COUNTRY_CODE,
                sortOrder: 1,
            });
        }
        return physicians;
    }
    /**
     * @function getPharmacy
     * @param data
     */
    getPharmacy(data) {
        const pharmacies = [];
        const name = (0, helper_1.substrInBetweenNew)(data, "Pharmacy:", "\n");
        const phoneNoRaw = (0, helper_1.substrInBetweenNew)(data, "Work Phone:", "\n");
        const phoneNo = (0, helper_1.changeNumberUSFormat)((0, helper_1.trim)(phoneNoRaw.replace(/[\s-()]/g, "")));
        if (name && phoneNo) {
            pharmacies.push({
                name,
                phoneNo,
                countryCode: EmrConstants_1.DEFAULT_COUNTRY_CODE,
                sortOrder: 1,
            });
        }
        return pharmacies;
    }
    getCaregiver(data) {
        const caregivers = [];
        const name = (0, helper_1.substrInBetweenNew)(data, "Emergency Contact:", "\n");
        const homePhoneNoRaw = (0, helper_1.substrInBetweenNew)(data, "Home Phone:", "\n");
        const homePhoneNo = (0, helper_1.changeNumberUSFormat)((0, helper_1.trim)(homePhoneNoRaw.replace(/[\s-()]/g, "")));
        const cellPhoneNoRaw = (0, helper_1.substrInBetweenNew)(data, "Cell Phone:", "\n");
        const cellPhoneNo = (0, helper_1.changeNumberUSFormat)((0, helper_1.trim)(cellPhoneNoRaw.replace(/[\s-()]/g, "")));
        const phoneNo = cellPhoneNo || homePhoneNo;
        if (name && phoneNo) {
            caregivers.push({
                name,
                phoneNo,
                countryCode: EmrConstants_1.DEFAULT_COUNTRY_CODE,
                sortOrder: 1,
            });
        }
        return caregivers;
    }
    /**
     * @function patientPhoneNumberWithAddress
     * @param firstSession
     * @summary Patient number or Address both are same session
     */
    patientPhoneNumberWithAddress(firstSession) {
        const info = {
            phoneNo: "",
            address: {
                placeName: "",
                apartmentNo: "",
            },
        };
        const numbers = (0, helper_1.substrInBetween)(firstSession, "Patient Phone:", "Visit Phone:");
        const number = (0, helper_1.trim)(numbers.replace(/[\s-()]/g, ""));
        info.phoneNo = (0, helper_1.changeNumberUSFormat)(number);
        const addressString = (0, helper_1.substrInBetween)(firstSession, "Permanent Address:", "\n");
        info.address.placeName = (0, helper_1.trim)(addressString);
        return info;
    }
    /**
     * @function patientName
     * @param sessionFirst {String}
     * @summary Getting Patient First name, Last name from string
     * @returns {name} FullName
     */
    patientName(sessionFirst) {
        const name = {
            firstName: "",
            lastName: "",
        };
        const breakName = sessionFirst.split(",");
        name.firstName = breakName[1];
        name.lastName = breakName[0];
        return name;
    }
}
exports.NDocs = NDocs;
